export default "__VITE_ASSET__Q2fH_V5a__"